import { LOGO } from '@/lib/brand';

/**
 * The app's mark, in whichever copy suits the theme.
 *
 * Two `<img>` tags with a CSS swap rather than one tag with a JavaScript
 * choice, and the reason is the first paint: the theme is applied to the
 * document before React runs (see lib/theme.tsx), so a component that picked in
 * JavaScript would render the wrong mark on the server, ship it in the HTML,
 * and flip it a moment later. The browser fetches only the one it draws.
 *
 * When a brand has a single file for both themes the second tag would be the
 * same image twice, so it is not rendered at all.
 */
export default function BrandMark({ className = '' }: { className?: string }) {
  if (LOGO.light === LOGO.dark) {
    // eslint-disable-next-line @next/next/no-img-element -- a small chrome icon;
    // next/image would add a wrapper and a request for no gain.
    return <img src={LOGO.dark} alt="" aria-hidden className={className} />;
  }
  return (
    <>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={LOGO.light} alt="" aria-hidden className={`${className} dark:hidden`} />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={LOGO.dark} alt="" aria-hidden className={`hidden ${className} dark:block`} />
    </>
  );
}
